/**
 * @file The notifications module.
 * @author Tom Verschoore de la Houssaije
 */
import { ComponentRegistry } from '../core/component-registry';
import { NotificationsViewComponent } from './notifications-view/notifications-view.component';
import { NotificationsListComponent } from './notifications-list/notifications-list.component';
import { AbsenceDetailComponent } from './absence-detail/absence-detail.component';
import { ExchangeListComponent } from './exchange-list/exchange-list.component';
import { ExchangeDayComponent } from './exchange-day/exchange-day.component';
import { ExchangeDayDetailComponent } from './exchange-day-detail/exchange-day-detail.component';
import { ExchangeDetailComponent } from './exchange-detail/exchange-detail.component';
import { ReassignFormComponent } from './reassign-form/reassign-form.component';
import { ReassignDayComponent } from './reassign-day/reassign-day.component';
import { ReassignDayDetailComponent } from './reassign-day-detail/reassign-day-detail.component';
import { ReassignDetailComponent } from './reassign-detail/reassign-detail.component';
/**
 * The notifications module.
 * @export
 * @class NotificationsModule
 */
var NotificationsModule = /** @class */ (function () {
    /**
     * Creates an instance of NotificationsModule.
     */
    function NotificationsModule() {
        ComponentRegistry.register('list', 'NotificationsListComponent', NotificationsListComponent);
        ComponentRegistry.register('overlay', 'ReassignDayComponent', ReassignDayComponent);
        ComponentRegistry.register('overlay', 'ReassignFormComponent', ReassignFormComponent);
        ComponentRegistry.register('overlay', 'ExchangeDayComponent', ExchangeDayComponent);
        ComponentRegistry.register('overlay', 'ExchangeListComponent', ExchangeListComponent);
        ComponentRegistry.register('route', 'ExchangeDayDetailComponent', ExchangeDayDetailComponent);
        ComponentRegistry.register('route', 'ExchangeDetailComponent', ExchangeDetailComponent);
        ComponentRegistry.register('route', 'ReassignDayDetailComponent', ReassignDayDetailComponent);
        ComponentRegistry.register('route', 'ReassignDetailComponent', ReassignDetailComponent);
        ComponentRegistry.register('route', 'AbsenceDetailComponent', AbsenceDetailComponent);
        ComponentRegistry.register('route', 'NotificationsViewComponent', NotificationsViewComponent);
    }
    return NotificationsModule;
}());
export { NotificationsModule };
